<template>
  <div class="w-full print:hidden">
    <h1 class="text-2xl">داشبورد</h1>
    <h3 class="text-muted mt-2">{{ $store.state.user.name }} - {{ $store.state.user.role.name }}</h3>
    <hr class="border border-dark-line mt-8">
  </div>

  <!--  <div class="flex justify-between gap-x-10 mt-4 print:hidden">-->

  <!--    <HomepageStatCard-->
  <!--        title="فروش امروز"-->
  <!--        text="10,000,000 تومان"-->
  <!--        percent="3.6">-->
  <!--      <DollarIcon/>-->
  <!--    </HomepageStatCard>-->

  <!--    <HomepageStatCard-->
  <!--        title="فاکتور های امروز"-->
  <!--        text="300 عدد"-->
  <!--        percent="+2.6">-->
  <!--      <UsersIcon class="fill-blue"/>-->
  <!--    </HomepageStatCard>-->

  <!--    <HomepageStatCard-->
  <!--        title="سفارش های امروز"-->
  <!--        text="50 عدد"-->
  <!--        percent="-13.2">-->
  <!--      <BookmarkIcon class="fill-orange"/>-->
  <!--    </HomepageStatCard>-->

  <!--    <HomepageStatCard-->
  <!--        title="مشتری های امروز"-->
  <!--        text="320 نفر"-->
  <!--        percent="+0.6">-->
  <!--      <UsersIcon class="fill-blue"/>-->
  <!--    </HomepageStatCard>-->

  <!--  </div>-->

  <VPanel class="relative mt-8 p-6 print:hidden">
    <VLoadingScreen :show="loading"/>

    <div class="flex justify-between mb-6">
      <h1 class="text-xl">سفارشات {{ $helper.renderCategoryType($route.params.type) }}</h1>
      <div class="flex mt-2 md:mt-0">
        <VInput type="number" placeholder="شماره اتاق ..." class="ml-4" v-model="filter.roomNumber"/>
        <select class="w-full rounded-lg bg-dark-form" v-model="filter.status">
          <option value="">همه</option>
          <option value="pending">در انتظار</option>
          <option value="seen">دیده شده</option>
          <option value="delivered">تحویل شده</option>
        </select>
      </div>
    </div>

    <table class="w-full text-right">
      <thead>
      <tr class="text-sm text-muted">
        <th>شماره اتاق</th>
        <th>محصولات</th>
        <th>پرداخت</th>
        <th>پرینت</th>
        <th>تاریخ</th>
      </tr>
      </thead>
      <tr v-for="(order, orderIndex) in orders.data"
          :key="order.id"
          class="text-muted-lighter">
        <td>{{ order.room.number }}</td>
        <td>
          <table class="w-full mt-5 border border-dark-line p-2">
            <thead>
            <tr class="text-muted">
              <th class="p-4">نام محصول</th>
              <th>تعداد</th>
              <th>توضیحات</th>
              <th>تاریخ ها</th>
              <th>وضعیت</th>
              <th>عملیات</th>
            </tr>
            </thead>
            <tbody>
            <tr v-for="(item, itemIndex) in order.items"
                :key="item.id">
              <td class="flex items-center p-2">
                <img class="w-24 rounded-lg ml-2"
                     :src="item.product.photo.path"
                     alt="">
                <span>{{ item.product.name }}</span>
              </td>
              <td>{{ item.count }}</td>
              <td>{{ item.description || '-' }}</td>
              <td class="text-sm">
                <span>دیده شده: {{ item.seen_date || '-' }}</span>
                <br>
                <span>تایید یا رد: {{ item.delivered_or_rejected_date || '-' }}</span>
              </td>
              <td>
                <VBadge :type="$helper.renderStatusClass(item.status)">
                  {{ $helper.renderStatus(item.status) }}
                </VBadge>
              </td>
              <td>
                <a href="#" @click.prevent="updateInvoiceItem(orderIndex, itemIndex, item)">
                  <PenIcon class="text-orange"/>
                </a>
              </td>
            </tr>
            </tbody>
          </table>
        </td>
        <td>
          <VBadge class="mr-2" :type="$helper.renderStatusClass(order.payment_status)">
            {{ $helper.renderStatus(order.payment_status) }}
          </VBadge>
        </td>
        <td>
          <a href="#" @click.prevent="modalPrint = true; printOrder = order">
            <PrintIcon class="fill-blue"/>
          </a>
        </td>
        <td>{{ order.created_at }}</td>
      </tr>
    </table>

    <!-- Pagination -->
    <div class="flex justify-center mt-5 w-full gap-x-5" v-if="orders.data">
      <div class="px-3 py-2 border border-accent rounded-lg cursor-pointer"
           v-for="(item, index) in Math.floor(orders.total/orders.per_page)"
           :key="index"
           :class="{'bg-accent' : index + 1 === orders.current_page}"
           @click="current_page = index + 1">
        {{ index + 1 }}
      </div>
    </div>

  </VPanel>

  <ModalOrderStatus
      :show="modalStatus"
      title="تغییر وضعیت سفارش"
      @updated="invoiceItemUpdated"
      @click="modalStatus = !modalStatus"
      :invoice-item="invoiceItem"/>

  <ModalPrintOrder
      :show="modalPrint"
      :order="printOrder"
      @click="modalPrint = !modalPrint"
  />

</template>

<script>
// @ is an alias to /src
import VPanel from "@/components/VPanel";
import PrintIcon from "@/components/Icons/PrintIcon";
import {getOrders} from "@/API/API";
import VLoadingScreen from "@/components/General/VLoadingScreen";
import VInput from "@/components/General/VInput";
import PenIcon from "@/components/Icons/PenIcon";
import ModalOrderStatus from "@/components/Modal/ModalOrderStatus";
import VBadge from "@/components/General/VBadge";
import ModalPrintOrder from "@/components/Modal/ModalPrintOrder";
import {mapState} from "vuex";

export default {
  name: 'OrdersView',
  components: {
    ModalPrintOrder,
    VBadge,
    ModalOrderStatus,
    PenIcon,
    VInput,
    VLoadingScreen,
    PrintIcon,
    VPanel,
  },
  data() {
    return {
      orders: [],
      printOrder: {},

      loading: true,
      modalStatus: false,
      modalPrint: false,

      orderIndex: '',
      invoiceItem: {},
      invoiceIndex: '',

      filter: {
        roomNumber: '',
        status: ''
      },
      current_page: 1,

    }
  },
  computed: {
    ...mapState(['fcmMessage'])
  },
  async created() {
    this.orders = (await getOrders(this.$route.params.type)).data
    this.loading = false
  },
  methods: {
    renderStatusClass(status) {
      switch (status) {
        case 'pending':
          return 'text-orange bg-orange/20 '
        case 'seen':
          return 'text-blue bg-blue/20 '
        case 'delivered':
          return 'text-green bg-green/20 '
        case 'rejected':
          return 'text-red bg-red/20 '
      }
    },
    updateInvoiceItem(orderIndex, itemIndex, item) {
      this.modalStatus = true
      this.invoiceIndex = itemIndex
      this.orderIndex = orderIndex
      this.invoiceItem = item
    },
    invoiceItemUpdated(invoiceItem) {
      this.modalStatus = false
      this.orders.data[this.orderIndex].items[this.invoiceIndex] = invoiceItem
    },
    async getOrders() {
      this.loading = true
      this.orders = (await getOrders(this.$route.params.type, this.current_page, this.filter.roomNumber, this.filter.status)).data
      this.loading = false
    }
  },
  watch: {
    '$route'() {
      if (this.$route.params.type) {
        this.getOrders()
      }
    },
    'filter.roomNumber'() {
      this.getOrders()
    },
    'filter.status'() {
      this.getOrders()
    },
    'current_page'() {
      this.getOrders()
    },
    'fcmMessage'(fcmMessage) {
      if (fcmMessage.data.order) {
        // console.log(fcmMessage.data.order)
        this.orders.data.unshift(JSON.parse(fcmMessage.data.order))
      }
    },
  }
}
</script>
